export default {
  common: {
    embed_error: 'Dieses Dokument muss in einem neuen Tab geöffnet werden.',
    no_content: 'Modal content not found',
    close: 'Schliessen'
  },
  file_uploader: {
    upload_choose_link: 'auswählen',
    upload_documents_html: 'Dokumente %{link}',
    upload_success: 'Erfolgleich hochgeladen',
    upload_fail: 'Fehler beim Upload',
    upload_too_big:
      'Hochladen der Datei "{file}" ist fehlgeschlagen. Das Dokument darf die Dateigrösse von 20 MB nicht überschreiten.',
    upload_wrong_type: 'Der Dokumenttyp der Datei "{file}" wird nicht unterstützt.',
    of: 'von'
  },
  zefix: {
    input: 'Bitte geben Sie mindestens drei Buchstaben ein.',
    error: 'Unbekannter Fehler, bitte später nochmals versuchen.'
  },
  adia_ident: {
    no_connected_advisors: 'Keine verbundenen Berater'
  }
}
